import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
import axios from 'axios'
Vue.prototype.$axios = axios
// Vue.prototype.ss = '/api/website/index/';
Vue.prototype.ss = 'http://www.bxy123.com/prod-api/website/index/';
import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.prototype.$AOS = AOS
import animated from 'animate.css'
import wow from 'wowjs'
Vue.prototype.$wow = wow
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  setTimeout(()=>{
    next()
  },100)
})

Vue.use(ElementUI);
Vue.use(wow)
Vue.use(AOS)
// Vue.use(animated)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
